import {API} from "./config";
import {axiosClientDelivery, handleRequest} from "./axiosClient";
import {convertKeysToCamelCase} from "../utils";

export const getShippingProviders = async () => {
    const url = `${API.delivery.shippingProviders}`;
    const response = await handleRequest(axiosClientDelivery.get(url));
    const newResponse = {
        data: convertKeysToCamelCase(response?.data?.data),
        success: response?.success,
        status: response?.status,
    }
    return {...newResponse};
};

export const updateShippingProviders = (params) => {
    const url = `${API.delivery.updateShippingProviders}`;
    return handleRequest(axiosClientDelivery.post(url, params));
}
export const getPickupTime = async () => {
    const url = `${API.delivery.pickupTime}`;
    const response = await handleRequest(axiosClientDelivery.get(url));
    const newResponse = {
        data: convertKeysToCamelCase(response?.data?.data),
        success: response?.success,
        status: response?.status,
    }
    return {...newResponse};
};